module.exports = __webpack_public_path__ + "static/unternehmer-sechzig-c3f535adde868f624ddc015b6754a00b.svg";